'use strict';
window.Helpers = {
    goBack: function() {
        window.history.back();
    }
};